import { useAuth } from "@/contexts/AuthContext";
import { ChevronRight, LogOut } from "lucide-react";
import { inter } from "@/lib/fonts";
import { routes } from "@/lib/constants";

interface ProfileLogoutButtonProps {
  label?: string;
}

export function ProfileLogoutButton({
  label = "Logout",
}: ProfileLogoutButtonProps) {
  const { logout } = useAuth();

  return (
    <button
      type="button"
      onClick={() => logout(routes.auth.login)}
      className="flex w-full items-center justify-between gap-4 border-b border-b-gray-100 pb-4 mb-4 text-left cursor-pointer"
    >
      <div className="flex items-center gap-4">
        <LogOut strokeWidth={1.5} />
        <p className={`text-sm ${inter.className}`}>{label}</p>
      </div>
      <div>
        <ChevronRight strokeWidth={1} />
      </div>
    </button>
  );
}
